import * as React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { AddOption } from './AddOption'
import { useListActions } from './hooks'
import { DeleteDialog } from './DeleteDialog'
import { DropdownOption } from './DropdownOption'
import { useDragData, DraggableItemWrapper } from '@user/utils/Draggable'

export function DropdownOptionList() {
  const actions = useListActions()

  const {
    caption,
    options,
    addOption,
    onDragEnd,
    deleteDialog,
    onRemoveOption,
  } = actions

  const { containerRef, draggingIndex, itemRefs, offsets } = useDragData({
    dataList: options,
    onDragEnd,
  })

  return (
    <>
      <Box display="flex" mt={3} mb={1}>
        <Typography variant="subtitle2">Options</Typography>
        <Typography variant="caption" sx={{ ml: 'auto' }}>
          {caption}
        </Typography>
      </Box>

      <AddOption {...addOption} />

      <DeleteDialog {...deleteDialog} />

      <Box mt={1.2} ref={containerRef} id="options">
        {options.map((row, i) => (
          <DraggableItemWrapper
            key={row.id}
            ref={(el) => (itemRefs.current[i] = el as HTMLDivElement | null)}
            draggingIndex={draggingIndex}
            index={i}
            offsets={offsets}
            itemHeight="fit"
          >
            <DropdownOption index={i} onRemove={onRemoveOption} />
          </DraggableItemWrapper>
        ))}
      </Box>
    </>
  )
}
